// Corsican translations
export const co: Record<string, string> = {
  'menu.dashboard': 'Pannellu di cuntrollu',
  'menu.customers': 'Clienti',
  'menu.products': 'Prudutti',
  'menu.users': 'Utilizatori',
  'menu.settings': 'Paràmetri',
  'menu.logout': 'Scunnette',
  'dashboard.title': 'Pannellu di cuntrollu',
  'dashboard.newOrder': 'Ordine novu',
  'order.title': 'Ordine novu',
  'order.customer': 'Cliente',
  'order.products': 'Prudutti',
  'order.total': 'Tutale',
  'users.title': 'Utilizatori',
  'users.name': 'Nome',
  'users.email': 'Email',
  'common.yes': 'Iè',
  'common.no': 'Innò',
  'common.cancel': 'Annullà',
  'common.save': 'Salvà',
  'common.search': 'Circà',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Cunnette',
  'login.welcome': 'Benvenuti, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telefonu',
  'menu.reportsAndAccounting': 'Rapporti è Cuntabilità',
  'menu.systemAndCommunication': 'Sistema è Cumunicazione',
};